var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        { staticClass: "pr-0" },
        [
          _c("v-text-field", {
            attrs: {
              dense: _vm.dense,
              label: _vm.label,
              hint: "Year-Month-Day",
              rules: _vm.dateRules,
              disabled: _vm.disabled || _vm.disabledDate,
            },
            scopedSlots: _vm._u([
              {
                key: "prepend-inner",
                fn: function () {
                  return [
                    _c(
                      "v-menu",
                      {
                        staticClass: "d-inline",
                        attrs: {
                          "close-on-content-click": false,
                          transition: "scale-transition",
                          "offset-y": "",
                          "min-width": "290px",
                          disabled: _vm.disabled,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function (ref) {
                              var on = ref.on
                              return [
                                _c("v-icon", _vm._g({}, on), [_vm._v("event")]),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.dateMenu,
                          callback: function ($$v) {
                            _vm.dateMenu = $$v
                          },
                          expression: "dateMenu",
                        },
                      },
                      [
                        _c("v-date-picker", {
                          attrs: { min: _vm.minDate, max: _vm.maxDate },
                          on: {
                            change: function ($event) {
                              _vm.dateMenu = false
                            },
                          },
                          model: {
                            value: _vm.date,
                            callback: function ($$v) {
                              _vm.date = $$v
                            },
                            expression: "date",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.date,
              callback: function ($$v) {
                _vm.date = $$v
              },
              expression: "date",
            },
          }),
        ],
        1
      ),
      _c(
        "v-col",
        { staticClass: "pl-0" },
        [
          _c("v-text-field", {
            attrs: {
              dense: _vm.dense,
              prefix: "at",
              hint: "24-hour time",
              rules: _vm.timeRules,
              disabled: _vm.disabled,
            },
            scopedSlots: _vm._u([
              {
                key: "append",
                fn: function () {
                  return [
                    _c(
                      "v-menu",
                      {
                        staticClass: "d-inline",
                        attrs: {
                          "close-on-content-click": false,
                          transition: "scale-transition",
                          "offset-y": "",
                          "offset-x": "",
                          "min-width": "290px",
                          disabled: _vm.disabled,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function (ref) {
                              var on = ref.on
                              return [
                                _c("v-icon", _vm._g({}, on), [_vm._v("alarm")]),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.timeMenu,
                          callback: function ($$v) {
                            _vm.timeMenu = $$v
                          },
                          expression: "timeMenu",
                        },
                      },
                      [
                        _c("v-time-picker", {
                          ref: "timePicker",
                          attrs: { format: "24hr" },
                          on: { change: _vm.closeTimePicker },
                          model: {
                            value: _vm.time,
                            callback: function ($$v) {
                              _vm.time = $$v
                            },
                            expression: "time",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.time,
              callback: function ($$v) {
                _vm.time = $$v
              },
              expression: "time",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }